export const DELETE_SCHEDULED_TASK_REQUEST = 'DELETE_TASK_REQUEST';
export const DELETE_SCHEDULED_TASK_SUCCESS = 'DELETE_TASK_SUCCESS';
export const DELETE_SCHEDULED_TASK_FAIL = 'DELETE_TASK_FAIL';
export const DELETE_SCHEDULED_TASK_RESET = 'DELETE_SCHEDULED_TASK_RESET';